

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    data: null,
    investor_types: []
}

const investorDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_INVESTOR_DETAILS:
            return {
                ...state,
                data: action.data
            }
        case actionTypes.SET_INVESTOR_TYPES:
            return {
                ...state,
                investor_types: action.investor_types
            }
        default:
            return state; 
    }
}

export default investorDetailsReducer
